export default class GeocodeResult {
  constructor(result, defaultValue = "") {
    this.result = this._normalizeResult(result);
    this.defaultValue = defaultValue;
  }

  get street() {
    const streetNumber = this._findAddressComponent("street_number");
    const route = this._findAddressComponent("route");

    if (streetNumber) {
      return `${streetNumber.long_name} ${route.long_name}`;
    } else if (route) {
      return route.long_name;
    } else {
      return this.defaultValue;
    }
  }

  get city() {
    const locality = this._findAddressComponent("locality");
    const sublocality = this._findAddressComponent("sublocality");

    return locality?.long_name || sublocality?.long_name || this.defaultValue;
  }

  get state() {
    const state = this._findAddressComponent("administrative_area_level_1");

    return state?.short_name || this.defaultValue;
  }

  get zipCode() {
    const zipCode = this._findAddressComponent("postal_code");

    return zipCode?.short_name || this.defaultValue;
  }

  get country() {
    const country = this._findAddressComponent("country");

    return country?.long_name || this.defaultValue;
  }

  get formattedAddress() {
    return this.result.formatted_address;
  }

  get latitude() {
    return this.result.geometry.location.lat;
  }

  get longitude() {
    return this.result.geometry.location.lng;
  }

  // Private

  _findAddressComponent(name) {
    return this.result.address_components.find((component) => {
      return component.types.includes(name);
    });
  }

  _normalizeResult(result) {
    return JSON.parse(JSON.stringify(result));
  }
}
